import { AxiosResponse } from "axios";
import BaseAPI from "../../api/api";

const path: string = "front-api";

export type formPollListType = {
  search?: string;
  id_poll_type?: number;
  page?: number;
  limit?: number;
};
export enum USER_TYPE {
  EMPLOYEE = "employee",
  STUDENT = "student",
  MEMBER = "MEMBER",
}
export enum CONTENT_TYPE {
  CONTENT = "CONTENT",
  NEWS = "NEWS",
  ACTIVITY = "ACTIVITY",
  ADMISSION = "ADMISSION",
}
export type sendFormPoll = {
  id_form_poll: number;
  id_form_poll_choice: number;
  auth_required: boolean;
};
export type galleryListType = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
  search?: string;
  start_date?: string;
  end_date?: string;
  id_gallery_type?: number;
  type?: string;
};
export type galleryLikeShare = {
  type_share_like: "LIKE" | "DISLIKE" | "SHARE";
  social_media?: "LINE" | "Facebook" | "X";
};
export type bannerSlideType = {
  keyword?: string;
  banner_group: string;
  limit?: number;
  page?: number;
};
export type newsType = {
  keyword?: string;
  id_category?: number;
  content_status_name?: string;
  sortBy?: string;
  sortType?: string;
  limit?: number;
  page?: number;
};
export type activityList = {
  keyword?: string;
  id_activity_category?: number;
  content_status_name?: string;
  sortBy?: string;
  sortType?: string;
  limit?: number;
  page?: number;
  id_content?: number;
};
export type collaborationNetworkType = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
};
export type globalSearchType = {
  keyword?: string;
  search_with?: "WITH_TITLE" | "WITH_DETAIL";
  content_type?: string;
};
export type categoryType = {
  page?: number;
  limit?: number;
  keyword?: string;
};

export class FrontApi extends BaseAPI {
  static header(): Promise<AxiosResponse> {
    return this.api.get(`${path}/header`);
  }
  static menuHeader(): Promise<AxiosResponse> {
    return this.api.get(`menu/tree`);
  }
  static footer(): Promise<AxiosResponse> {
    return this.api.get(`${path}/footer`);
  }

  static departmentList(): Promise<AxiosResponse> {
    return this.api.get(`${path}/department/list`);
  }
  static employeeList(query: {
    id_department: number;
  }): Promise<AxiosResponse> {
    return this.api.get(`${path}/employee/list`, { params: query });
  }
  static employeeDepartmentList(id_department: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/department/${id_department}/tree-department-employee`);
  }
  static employeeDetail(id_employee: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/employee/${id_employee}`);
  }
  static formPollList(query: formPollListType): Promise<AxiosResponse> {
    return this.api.get(`${path}/form-poll/list`, {
      params: query,
    });
  }
  static formPollMostPopular(limit: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/form-poll/most-popular`, {
      params: {
        limit,
      },
    });
  }
  static sendForm(body: sendFormPoll): Promise<AxiosResponse> {
    return this.api.post(`${path}/form-poll/send-form`, body);
  }
  static pollTypeList(): Promise<AxiosResponse> {
    return this.api.get(`${path}/poll-type/list`);
  }
  static galleryList(query: galleryListType): Promise<AxiosResponse> {
    return this.api.get(`${path}/gallery/list`, { params: query });
  }
  static findOneGallery(id_gallery: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/gallery/${id_gallery}`);
  }
  static likeSharedGallery(
    id_gallery: number,
    body: galleryLikeShare
  ): Promise<AxiosResponse> {
    return this.api.patch(`${path}/gallery/${id_gallery}/like-share`, body);
  }
  static likeSharedContent(
    id_content: number,
    body: galleryLikeShare
  ): Promise<AxiosResponse> {
    return this.api.patch(`${path}/news/${id_content}/like-share`, body);
  }
  static downloadGalleryImage(id_gallery: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/gallery/${id_gallery}/download-zip`, {
      responseType: "arraybuffer",
    });
  }
  static employeeDownload(id_employee: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/employee/${id_employee}/download`, {
      responseType: "arraybuffer",
    });
  }
  static banner(query: bannerSlideType): Promise<AxiosResponse> {
    return this.api.get(`${path}/banner`, {
      params: query,
    });
  }
  static news(query: newsType): Promise<AxiosResponse> {
    return this.api.get(`${path}/news`, { params: query });
  }
  static category(query: categoryType): Promise<AxiosResponse> {
    return this.api.get(`category`, { params: query });
  }
  static findOneContent(id_content: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/news/${id_content}`);
  }
  static findOneByContentNo(content_no: string): Promise<AxiosResponse> {
    return this.api.get(`${path}/news_by_no/${content_no}`);
  }
  static globalSearch(params: globalSearchType): Promise<AxiosResponse> {
    return this.api.get(`${path}/global-search`, { params: params });
  }
  static admission(): Promise<AxiosResponse> {
    return this.api.get(`${path}/admission`);
  }
  static activity(query: activityList): Promise<AxiosResponse> {
    return this.api.get(`${path}/activity`, { params: query });
  }
  static commentList(): Promise<AxiosResponse> {
    return this.api.get(`${path}/comment/list`);
  }
  static collaborationNetwork(
    query: collaborationNetworkType
  ): Promise<AxiosResponse> {
    return this.api.get(`${path}/collaboration-network/list`, {
      params: query,
    });
  }
  static activityCategoryDropdown(): Promise<AxiosResponse> {
    return this.api.get(`activity-category/dropdown`);
  }
  static galleryTypeDropdown(): Promise<AxiosResponse> {
    return this.api.get(`${path}/gallery-type/dropdown`)
  }
  static contact(): Promise<AxiosResponse> {
    return this.api.get(`${path}/contract`)
  }
}
